import type { FC } from 'react';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import { AxiosError } from 'axios';

import { useAuth } from '@/providers/auth-provider';

const isUnauthorized = (error: unknown) => {
  if (error instanceof AxiosError) {
    return error.response?.status === 401;
  }
  return false;
};

interface TanstackProviderProps {
  children: React.ReactNode;
}
const Provider: FC<TanstackProviderProps> = ({ children }) => {
  const { logout } = useAuth();
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        if (isUnauthorized(error)) {
          logout();
          throw redirect({ to: '/auth/login' });
        }
      },
    }),
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default Provider;
